// Timer. Word declension
function GetNoun(number, one, two, five) {
  let n = Math.abs(number);
  n %= 100;
  if (n >= 5 && n <= 20) return five;
  n %= 10;
  if (n === 1) return one;
  if (n >= 2 && n <= 4) return two;
  return five;
}

function getTimeRemaining(endtime) {
  let t = Date.parse(endtime) - Date.parse(new Date());
  let seconds = Math.floor((t / 1000) % 60);
  let minutes = Math.floor((t / 1000 / 60) % 60);
  let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  let days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    'total': t,
    'days': days,
    'hours': hours,
    'minutes': minutes,
    'seconds': seconds
  };
}

function initializeClock(id, endtime) {
  let clock = document.getElementById(id);
  let daysSpan = clock.querySelector('.days');
  let hoursSpan = clock.querySelector('.hours');
  let minutesSpan = clock.querySelector('.minutes');
  let secondsSpan = clock.querySelector('.seconds');

  // Добавляем элементы для текста
  let textDays = document.querySelector('#smallTextDays');
  let textHours = document.querySelector('#smallTextHours');
  let textMinutes = document.querySelector('#smallTextMinutes');
  let textSeconds = document.querySelector('#smallTextSeconds');

  function updateClock() {
    let t = getTimeRemaining(endtime);

    function displayDigits(zero = false) {
      let d = zero ? 0 : t.days;
      let h = zero ? 0 : t.hours;
      let m = zero ? 0 : t.minutes;
      let s = zero ? 0 : t.seconds;

      daysSpan.innerHTML = ('0' + d).slice(-2);
      hoursSpan.innerHTML = ('0' + h).slice(-2);
      minutesSpan.innerHTML = ('0' + m).slice(-2);
      secondsSpan.innerHTML = ('0' + s).slice(-2);

      // Обновляем склонения
      textDays.innerText = GetNoun(d, 'день', 'дні', 'днів');
      textHours.innerText = GetNoun(h, 'година', 'години', 'годин');
      textMinutes.innerText = GetNoun(m, 'хвилина', 'хвилини', 'хвилин');
      textSeconds.innerText = GetNoun(s, 'секунда', 'секунди', 'секунд');
    }

    if (t.total <= 0) {
      displayDigits(true);
      return;
    }

    displayDigits();
  }

  updateClock();
  let timeinterval = setInterval(updateClock, 1000);
}

let deadline="December 05 2025 23:59:59 GMT+0200"; //for Ukraine
initializeClock('clockdiv', deadline);
